import type {LocalizedTypeValue} from '@/hooks/use-app-config'

/**
 * Resolve the singular per-locale label for a type value (from the app-config
 * type-value translations). Used by promoted by-type pages to render the
 * Create button label as "Create {singular}" instead of "Create {plural}"
 * (issue 680). Falls back to English, then to the localized {@code label},
 * then undefined.
 */
export function pickTypeValueLabel(
    typeValues: ReadonlyArray<LocalizedTypeValue>,
    code: string,
    lang: string,
): string | undefined {
    const entry = typeValues.find((t) => t.code === code)
    if (!entry) return undefined
    const translations = entry.translations ?? {}
    const exact = translations[lang]?.label
    const baseLang = lang.split('-')[0]
    const base = baseLang ? translations[baseLang]?.label : undefined
    return exact ?? base ?? entry.label ?? undefined
}
